"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentalDetailsValidationSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
const revenue_pool_1 = require("../../revenue-pool/revenue-pool");
const managementCosts = zod_1.z.object({
    name: zod_1.z.string(),
    amount: zod_1.z.number(),
});
exports.RentalDetailsValidationSchema = zod_1.z
    .object({
    payoutInterval: zod_1.z.nativeEnum(enums_1.TPayoutInterval),
    contractType: zod_1.z.nativeEnum(enums_1.TContractType),
    contractStartDate: zod_1.z.coerce.date(),
    contractEndDate: zod_1.z.coerce.date(),
    expectedRentalStartDate: zod_1.z.coerce.date().nullable().default(null),
    occupancyRate: zod_1.z.number(),
    monthlyDistributionDate: zod_1.z.number(),
    rentalIncome: zod_1.z.number(),
    rentalSurplus: zod_1.z.number(),
    rentalReturn: zod_1.z.number().nullable(),
    managementFee: zod_1.z.number().nullable(),
    propertyManagementFee: zod_1.z.number().nullable(),
    liquidityReserve: zod_1.z.number(),
    additionalManagementCosts: zod_1.z.array(managementCosts),
    plannedFirstRentalIncomeDate: zod_1.z.coerce.date(),
    revenuePool: zod_1.z.union([zod_1.z.string(), revenue_pool_1.RevenuePoolSchema]),
})
    .partial()
    .refine((data) => {
    if (data.contractType === enums_1.TContractType.closed && !data.contractEndDate)
        return false;
    return true;
}, { message: 'The contract type is closed, but no end date was provided.' })
    .refine((data) => {
    if (data.contractStartDate &&
        data.contractType === enums_1.TContractType.open &&
        data.contractEndDate &&
        data.contractEndDate > data.contractStartDate)
        return false;
    return true;
}, { message: 'The contract end date can not be earlier than the start date.' });
//# sourceMappingURL=rentalDetails.js.map